import * as React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import type { Session } from "../api/session";

export default function SessionBar(props: { session: Session; onLogout: () => void }) {
  const { session, onLogout } = props;
  const fullName = [session.firstName, session.lastName].filter(Boolean).join(" ");

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{ xs: 1, sm: 1.5 }}
      sx={{
        position: "fixed",
        top: { xs: 10, sm: 16 },
        right: { xs: 10, sm: 16 },
        zIndex: 1300,
        maxWidth: { xs: "calc(100vw - 20px)", sm: "auto" },
        borderRadius: 999,
        pl: { xs: 1.5, sm: 2 },
        pr: { xs: 0.75, sm: 1 },
        py: 0.75,
        bgcolor: "rgba(9,5,11,0.72)",
        border: "1px solid rgba(168,85,247,0.35)",
        backdropFilter: "blur(14px)",
        boxShadow: "0 8px 28px rgba(0,0,0,0.35)",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          noWrap
          sx={{
            color: "#FFFFFF",
            fontWeight: 800,
            fontSize: { xs: 12.5, sm: 13.5 },
            lineHeight: 1.2,
          }}
        >
          {fullName ? (
            <>
              {fullName} <Box component="span" sx={{ color: "rgba(226,232,240,0.6)", fontWeight: 600 }}>({session.email})</Box>
            </>
          ) : (
            <Box component="span" sx={{ color: "rgba(226,232,240,0.85)", fontWeight: 700 }}>({session.email})</Box>
          )}
        </Typography>
      </Box>

      <Button
        onClick={onLogout}
        size="small"
        startIcon={<LogoutRoundedIcon sx={{ fontSize: 16 }} />}
        sx={{
          flexShrink: 0,
          color: "#E9D5FF",
          fontWeight: 800,
          fontSize: 12.5,
          textTransform: "none",
          borderRadius: 999,
          px: 1.25,
          minWidth: 0,
          "&:hover": { bgcolor: "rgba(168,85,247,0.18)" },
        }}
      >
        Log out
      </Button>
    </Stack>
  );
}
